module.exports = __webpack_public_path__ + "img/news_1_4.13a0f9f9.jpg";